<div class="visualization-posts" fxLayout="column">
    @if (isMobile()) {
        @if (contact?.props?._id !== "convidadoId") {
            @for (post of postsList; track $index) {
                <app-chat-message
                    [initials]="post.initials"
                    [message]="post.message"
                    [date]="post.date"
                    [postUserId]="post.userId"
                    [userName]="post.userName"
                    [userId]="contact.props._id"
                ></app-chat-message>
            }
        }
        @if (contact?.props?._id !== "convidadoId") {
            <div class="visualization-posts__new-comment">
                <dsn-input
                    placeholder="Adicione um comentário"
                    [noValidate]="true"
                    (onClick)="onOpenPosts()"
                    [readOnly]="true"
                ></dsn-input>
                @if (previewMode) {
                    <dsn-button-menu-chips
                        [disabled]="true"
                        [mainIcon]="
                            getUserLikeType() === 'liked'
                                ? 'fa-solid fa-thumbs-up'
                                : 'fa-regular fa-thumbs-up'
                        "
                        size="medium"
                    ></dsn-button-menu-chips>
                    <dsn-button-menu-chips
                        [disabled]="true"
                        [mainIcon]="
                            getUserLikeType() === 'disliked' ||
                            getUserLikeType() === 'doubts'
                                ? 'fa-solid fa-thumbs-down'
                                : 'fa-regular fa-thumbs-down'
                        "
                        size="medium"
                    ></dsn-button-menu-chips>
                } @else {
                    <dsn-button-menu-chips
                        [mainIcon]="
                            getUserLikeType() === 'liked'
                                ? 'fa-solid fa-thumbs-up'
                                : 'fa-regular fa-thumbs-up'
                        "
                        [options]="likeOptions"
                        size="medium"
                        (onSelectOption)="onSelectLikeOption($event)"
                    ></dsn-button-menu-chips>
                    <dsn-button-menu-chips
                        [mainIcon]="
                            getUserLikeType() === 'disliked' ||
                            getUserLikeType() === 'doubts'
                                ? 'fa-solid fa-thumbs-down'
                                : 'fa-regular fa-thumbs-down'
                        "
                        [options]="unlikeOptions"
                        size="medium"
                        (onSelectOption)="onSelectLikeOption($event)"
                    ></dsn-button-menu-chips>
                }
            </div>
        }
    } @else {
        @if (contact?.props?._id !== "convidadoId") {
            <div fxLayout="row" fxLayoutAlign="space-between none">
                <div fxLayout="row" class="gap-12">
                    @if (previewMode) {
                        <dsn-button-menu-chips
                            [disabled]="true"
                            [style]="
                                visualization.likes > 0
                                    ? 'margin-left: 16px;'
                                    : 'margin-left: 10px;'
                            "
                            [mainIcon]="
                                getUserLikeType() === 'liked'
                                    ? 'fa-solid fa-thumbs-up'
                                    : 'fa-regular fa-thumbs-up'
                            "
                            menuPosition="left"
                            size="medium"
                            [label]="
                                '' +
                                (previewMode
                                    ? visualization.likes
                                    : visualization.likes > 0
                                      ? visualization.likes
                                      : '')
                            "
                        ></dsn-button-menu-chips>
                        <dsn-button-menu-chips
                            [disabled]="true"
                            [mainIcon]="
                                getUserLikeType() === 'disliked' ||
                                getUserLikeType() === 'doubts'
                                    ? 'fa-solid fa-thumbs-down'
                                    : 'fa-regular fa-thumbs-down'
                            "
                            menuPosition="left"
                            size="medium"
                            [label]="
                                '' +
                                (previewMode
                                    ? visualization.dislikes
                                    : visualization.dislikes > 0
                                      ? visualization.dislikes
                                      : '')
                            "
                        ></dsn-button-menu-chips>
                    } @else {
                        <dsn-button-menu-chips
                            [style]="
                                visualization.likes > 0
                                    ? 'margin-left: 16px;'
                                    : 'margin-left: 10px;'
                            "
                            [mainIcon]="
                                getUserLikeType() === 'liked'
                                    ? 'fa-solid fa-thumbs-up'
                                    : 'fa-regular fa-thumbs-up'
                            "
                            [options]="likeOptions"
                            menuPosition="left"
                            size="medium"
                            [label]="
                                '' +
                                (previewMode
                                    ? visualization.likes
                                    : visualization.likes > 0
                                      ? visualization.likes
                                      : '')
                            "
                            (onSelectOption)="
                                onSelectLikeOption($event, 'liked')
                            "
                        ></dsn-button-menu-chips>
                        <dsn-button-menu-chips
                            [mainIcon]="
                                getUserLikeType() === 'disliked' ||
                                getUserLikeType() === 'doubts'
                                    ? 'fa-solid fa-thumbs-down'
                                    : 'fa-regular fa-thumbs-down'
                            "
                            [options]="unlikeOptions"
                            menuPosition="left"
                            size="medium"
                            [label]="
                                '' +
                                (previewMode
                                    ? visualization.dislikes
                                    : visualization.dislikes > 0
                                      ? visualization.dislikes
                                      : '')
                            "
                            (onSelectOption)="
                                onSelectLikeOption($event, 'disliked')
                            "
                        ></dsn-button-menu-chips>
                    }
                </div>

                @if (
                    visualization?.postsLike?.length &&
                    previewMode &&
                    !isMobile()
                ) {
                    <dsn-button
                        [prelabel]="''"
                        [label]="'Ver interações'"
                        [type]="'secondary'"
                        [size]="'medium'"
                        [disabled]="false"
                        [iconLeft]="''"
                        [iconRight]="''"
                        [iconLeftCustom]="''"
                        [iconRightCustom]="''"
                        [active]="true"
                        [fontWeight]="'bold'"
                        [onlyIcon]="''"
                        [typeButton]="'button'"
                        (onClick)="onOpenInteractionsDialog()"
                    ></dsn-button>
                }
            </div>

            <div class="visualization-posts__divider"></div>
            <app-comments-post
                [company]="company"
                [report]="report"
                [options]="options"
                [visualization]="visualization"
            ></app-comments-post>
        }
    }
</div>
